<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Case of William Smith</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2-title_page.vue?0708247f